const quizData = {
  easy: [
    {
      question: "물이 어떤 상태로 존재할 수 있나요?",
      options: ["기체", "고체", "액체", "모두"],
      answer: "모두",
    },
    {
      question: "우리는 하루에 가장 많이 물을 어디에 사용하나요?",
      options: ["샤워", "양치", "빨래", "화장실"],
      answer: "화장실",
    },
  ],
  normal: [
    {
      question: "물이 고체, 액체, 기체로 존재할 수 있는 이유는?",
      options: ["온도 변화", "태양 빛", "산소량", "지구 자전"],
      answer: "온도 변화",
    },
    {
      question: "물의 순환에서 바다에서 증발한 물이 하늘로 올라가는 것을 무엇이라고 하나요?",
      options: ["응결", "증발", "강수", "침투"],
      answer: "증발",
    },
    {
      question: "지하수는 어떤 과정을 통해 생기나요?",
      options: ["식물 광합성", "응결", "땅속 침투", "강수"],
      answer: "땅속 침투",
    },
  ],
  hard: [
    {
      question: "지구 전체 물 중 식수로 직접 사용할 수 있는 비율은?",
      options: ["약 10%", "약 3%", "약 1%", "약 20%"],
      answer: "약 1%",
    },
    {
      question: "오염된 물을 마시면 주로 발생하는 질병은?",
      options: ["감기", "위장염", "폐렴", "골다공증"],
      answer: "위장염",
    },
    {
      question: "물 부족 국가가 아닌 곳은 어디인가요?",
      options: ["인도", "사우디아라비아", "네덜란드", "에티오피아"],
      answer: "네덜란드",
    }
  ],
};

export default quizData;
